import $ from 'jquery';

class Form {
    constructor() {
        this.form = $('.form');
        this.formInput = $('.form__control-input');
        this.formLabel = $('.form__control-label');
        this.events()
    }


    //Input focus
    events() {
        $.each(this.formInput, (i, el) => {

            if ($(el).val().length > 0) {
                $(el).parent().addClass('active');
            }

            $(el).on('focus', function () {
                $(this).parent().addClass('active');
            }).on('blur input', function () {
                if ($(this).val().length > 0) {
                    $(this).parent().addClass('active');
                } else {
                    $(this).parent().removeClass('active');
                }
            })
        })

        $.each(this.formLabel, (index, element) => {
            $(element).on('click', e => {
                var parent = $(e.currentTarget).parent();
                parent.addClass('active');
                parent.find('input').focus();
            })
        })
    }
}

export default Form;